import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { MR_NAV } from '@/constants/testIds';
import { House, MapTrifold, BookOpen, UserCircle, Bell } from '@phosphor-icons/react';

const tabs = [
  { key: 'home', label: 'Home', icon: House, path: '/mr', testId: MR_NAV.navHome },
  { key: 'beat', label: 'Beat Plan', icon: MapTrifold, path: '/mr/beat', testId: MR_NAV.navBeatPlan },
  { key: 'khata', label: 'Khata', icon: BookOpen, path: '/mr/khata', testId: MR_NAV.navKhata },
  { key: 'profile', label: 'Profile', icon: UserCircle, path: '/mr/profile', testId: MR_NAV.navProfile },
];

export default function MRLayout() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col mx-auto" style={{ background: '#F9F9FA', maxWidth: 480 }}>
      {/* Top Bar - Sticky */}
      <header className="sticky top-0 z-30 px-4 py-3 flex items-center justify-between"
        style={{ background: '#0A2540', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: 'rgba(255,255,255,0.12)' }}>
            <MapTrifold size={20} weight="duotone" color="white" />
          </div>
          <div>
            <p className="text-sm font-bold text-white" style={{ fontFamily: 'Manrope, sans-serif' }}>PharmaPro MR</p>
            <p className="text-[10px] font-medium" style={{ color: 'rgba(255,255,255,0.5)' }}>{user?.name}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: 'rgba(255,255,255,0.08)' }}>
            <Bell size={18} weight="duotone" color="white" />
          </button>
          <div className="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold"
            style={{ background: '#007AFF', color: 'white', border: '2px solid rgba(255,255,255,0.2)' }}>
            {user?.name?.charAt(0) || 'M'}
          </div>
        </div>
      </header>

      {/* Content - with safe padding for bottom nav */}
      <main className="flex-1 overflow-y-auto" style={{ paddingBottom: 80 }}>
        <Outlet />
      </main>

      {/* Bottom Navigation - Fixed, with safe area */}
      <nav data-testid={MR_NAV.bottomNav}
        className="fixed bottom-0 left-1/2 -translate-x-1/2 flex border-t z-30"
        style={{
          background: '#FFFFFF',
          borderColor: '#E2E4E9',
          maxWidth: 480,
          width: '100%',
          boxShadow: '0 -4px 20px rgba(0,0,0,0.06)',
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        }}>
        {tabs.map(tab => {
          const Icon = tab.icon;
          const active = location.pathname === tab.path || (tab.path !== '/mr' && location.pathname.startsWith(tab.path));
          const isHome = tab.path === '/mr' && location.pathname === '/mr';
          const isActive = active || isHome;
          return (
            <button
              key={tab.key}
              data-testid={tab.testId}
              onClick={() => navigate(tab.path)}
              className="flex-1 flex flex-col items-center py-2 transition-colors relative"
            >
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full" style={{ background: '#007AFF' }} />
              )}
              <div className="w-10 h-10 rounded-xl flex items-center justify-center transition-colors"
                style={{ background: isActive ? 'rgba(0,122,255,0.08)' : 'transparent' }}>
                <Icon size={22} weight={isActive ? 'fill' : 'regular'} style={{ color: isActive ? '#007AFF' : '#8A94A6' }} />
              </div>
              <span className="text-[10px] font-semibold mt-0.5" style={{ color: isActive ? '#007AFF' : '#8A94A6' }}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
